import { Chip, type SxProps, Tooltip } from '@mui/material';
import type React from 'react';
import { useAccount } from '../../contexts/AccountContext';

interface EstimatedCostChipProps {
  estimate: string;
  tooltipTitle?: string;
  sx?: SxProps;
}

export const EstimatedCostChip: React.FC<EstimatedCostChipProps> = ({
  estimate,
  tooltipTitle,
  sx,
}) => {
  const { account } = useAccount();

  const hideBillingChip = Boolean(account?.clientSettings?.hideBillingFromUsers ?? true);

  if (hideBillingChip) {
    return null;
  }

  const chip = (
    <Chip size="small" color="warning" label={estimate} sx={{ fontSize: '0.75rem', ...sx }} />
  );

  if (tooltipTitle) {
    return (
      <Tooltip title={tooltipTitle} slotProps={{ tooltip: { sx: { fontSize: '0.875rem', p: 1 } } }}>
        {chip}
      </Tooltip>
    );
  }

  return chip;
};
